import { newE2EPage } from "@stencil/core/testing";

describe("uic-output", () => {
    describe("supporting multi line values", () => {
        it("should not indicate multi-line display or limit on lines by default", async () => {
            const page = await newE2EPage({
                html: `<uic-output></uic-output>`
            });

            expect((await page.find("uic-output .uic-output__value--multiline")) != null).toBeFalsy();
            expect((await page.find("uic-output .uic-output__value--max-lines")) != null).toBeFalsy();
        });

        it("should indicate multi-line display on setting multiline attribute", async () => {
            const page = await newE2EPage({
                html: `<uic-output multiline></uic-output>`
            });

            expect((await page.find("uic-output .uic-output__value--multiline")) != null).toBeTruthy();
            expect((await page.find("uic-output .uic-output__value--max-lines")) != null).toBeFalsy();
        });

        it("should not indicate multi-line display or limit on lines on setting max-lines attribute to 1", async () => {
            const page = await newE2EPage({
                html: `<uic-output max-lines="1"></uic-output>`
            });

            expect((await page.find("uic-output .uic-output__value--multiline")) != null).toBeFalsy();
            expect((await page.find("uic-output .uic-output__value--max-lines")) != null).toBeFalsy();
        });

        it(
            "should indicate multi-line display and limit on lines on setting max-lines " + "attribute to value greater than 1",
            async () => {
                const page = await newE2EPage({
                    html: `<uic-output max-lines="2"></uic-output>`
                });

                expect((await page.find("uic-output .uic-output__value--multiline")) != null).toBeTruthy();
                expect((await page.find("uic-output .uic-output__value--max-lines")) != null).toBeTruthy();
            }
        );

        it("should not apply custom styling to output value on setting max-lines attribute to 1", async () => {
            const page = await newE2EPage({
                html: `<uic-output max-lines="1"></uic-output>`
            });

            const el = await page.find("uic-output .uic-output__value");
            const style = await el.getComputedStyle();

            expect(style.display).not.toEqual("-webkit-box");
            expect(style["-webkit-line-clamp"]).not.toEqual("1");
            expect(style["-webkit-box-orient"]).not.toEqual("vertical");
        });

        it("should apply custom styling to output value on setting max-lines attribute to value greater than 1", async () => {
            const page = await newE2EPage({
                html: `<uic-output max-lines="2"></uic-output>`
            });

            const el = await page.find("uic-output .uic-output__value");
            const style = await el.getComputedStyle();

            expect(style.display).toEqual("flow-root");
            expect(style["-webkit-line-clamp"]).toEqual("2");
            expect(style["-webkit-box-orient"]).toEqual("vertical");
        });

        it("should adopt defined limit on number of lines when applying custom styling", async () => {
            const page = await newE2EPage({
                html: `<uic-output max-lines="2"></uic-output>`
            });

            for (let i = 3; i < 30; i++) {
                await page.$eval(
                    "uic-output",
                    // eslint-disable-next-line
                    (el: any, count) => {
                        el.maxLines = count;
                    },
                    i
                );

                await page.waitForChanges();

                const el = await page.find("uic-output .uic-output__value");
                const style = await el.getComputedStyle();

                expect(style["-webkit-line-clamp"]).toEqual(String(i));
            }
        });

        it("should keep indicating multi-line display on clearing multiline attribute while keeping limit on lines", async () => {
            const page = await newE2EPage({
                html: `<uic-output max-lines="2" multiline></uic-output>`
            });

            expect((await page.find("uic-output .uic-output__value--multiline")) != null).toBeTruthy();
            expect((await page.find("uic-output .uic-output__value--max-lines")) != null).toBeTruthy();
            // eslint-disable-next-line
            await page.$eval("uic-output", (el: any) => {
                el.multiline = false;
            });

            await page.waitForChanges();

            expect((await page.find("uic-output .uic-output__value--multiline")) != null).toBeTruthy();
            expect((await page.find("uic-output .uic-output__value--max-lines")) != null).toBeTruthy();
        });

        it(
            "should not keep indicating multi-line display on reducing limit on lines to 1 " +
                "while keeping multiline attribute set",
            async () => {
                const page = await newE2EPage({
                    html: `<uic-output max-lines="2" multiline></uic-output>`
                });

                expect((await page.find("uic-output .uic-output__value--multiline")) != null).toBeTruthy();
                expect((await page.find("uic-output .uic-output__value--max-lines")) != null).toBeTruthy();
                // eslint-disable-next-line
                await page.$eval("uic-output", (el: any) => {
                    el.maxLines = 1;
                });

                await page.waitForChanges();

                expect((await page.find("uic-output .uic-output__value--multiline")) != null).toBeFalsy();
                expect((await page.find("uic-output .uic-output__value--max-lines")) != null).toBeFalsy();
            }
        );

        it(
            "should keep indicating multi-line display on lifting limit on lines while keeping" + " multiline attribute set",
            async () => {
                const page = await newE2EPage({
                    html: `<uic-output max-lines="2" multiline></uic-output>`
                });

                expect((await page.find("uic-output .uic-output__value--multiline")) != null).toBeTruthy();
                expect((await page.find("uic-output .uic-output__value--max-lines")) != null).toBeTruthy();
                // eslint-disable-next-line
                await page.$eval("uic-output", (el: any) => {
                    el.maxLines = Infinity;
                });

                await page.waitForChanges();

                expect((await page.find("uic-output .uic-output__value--multiline")) != null).toBeTruthy();
                expect((await page.find("uic-output .uic-output__value--max-lines")) != null).toBeFalsy();
            }
        );

        it(
            "should not keep indicating multi-line display on clearing multiline" + " attribute and reducing limit on lines to 1",
            async () => {
                const page = await newE2EPage({
                    html: `<uic-output max-lines="2" multiline></uic-output>`
                });

                expect((await page.find("uic-output .uic-output__value--multiline")) != null).toBeTruthy();
                expect((await page.find("uic-output .uic-output__value--max-lines")) != null).toBeTruthy();
                // eslint-disable-next-line
                await page.$eval("uic-output", (el: any) => {
                    el.multiline = false;
                    el.maxLines = 1;
                });

                await page.waitForChanges();

                expect((await page.find("uic-output .uic-output__value--multiline")) != null).toBeFalsy();
                expect((await page.find("uic-output .uic-output__value--max-lines")) != null).toBeFalsy();
            }
        );

        it(
            "should not keep indicating multi-line display on clearing multiline " + "attribute and lifting limit on lines",
            async () => {
                const page = await newE2EPage({
                    html: `<uic-output max-lines="2" multiline></uic-o utput>`
                });

                expect((await page.find("uic-output .uic-output__value--multiline")) != null).toBeTruthy();
                expect((await page.find("uic-output .uic-output__value--max-lines")) != null).toBeTruthy();
                // eslint-disable-next-line
                await page.$eval("uic-output", (el: any) => {
                    el.multiline = false;
                    el.maxLines = Infinity;
                });

                await page.waitForChanges();

                expect((await page.find("uic-output .uic-output__value--multiline")) != null).toBeFalsy();
                expect((await page.find("uic-output .uic-output__value--max-lines")) != null).toBeFalsy();
            }
        );
    });
});
